// src/persistentStorage/iconsIndexDB.ts
import {
  Stringified,
  ionicStorageClass,
} from "@/persistentStorage/ionicStorageClass";

/** Versão do esquema local. Mudar obriga a limpar as duas bases. */
export const ICONS_SCHEMA = "icons-v2-by-path";

export interface IIconRef {
  path: string;
  date: number;
}

/** Os registos de estado usam este prefixo e sufixo; as referências nunca. */
const META = (name: string) => `__${name}__`;
const isMetaKey = (key: string) => key.startsWith("__");

function safeParse<T>(raw: unknown, fallback: T): T {
  if (typeof raw !== "string") return fallback;
  try {
    return JSON.parse(raw) as T;
  } catch {
    return fallback;
  }
}

/**
 * Índice ecrã→ícone e estado da sincronização.
 *
 * Referências:  "1010|icons|close"  →  { path, date }
 * Estado:       "__schema__", "__lastUpdate__", "__fingerprint__", "__paths__"
 */
class IconsIndexDB extends ionicStorageClass {
  // ---- referências -------------------------------------------------------

  async getRefs(): Promise<Record<string, string>> {
    await this.ready;
    return safeParse<Record<string, string>>(
      await this.getDatabaseItem(META("refs")),
      {},
    );
  }

  async setRefs(map: Record<string, string>): Promise<void> {
    await this.ready;
    await this.setDatabaseItem(
      META("refs"),
      JSON.stringify(map) as Stringified<string>,
    );
  }

  // ---- estado ------------------------------------------------------------

  /** Mapa caminho→data do que está em cache. Uma leitura dá o estado todo. */
  async getPaths(): Promise<Record<string, number>> {
    await this.ready;
    const raw = await this.getDatabaseItem(META("paths"));
    return safeParse<Record<string, number>>(raw, {});
  }

  async setPaths(map: Record<string, number>): Promise<void> {
    await this.ready;
    await this.setDatabaseItem(
      META("paths"),
      JSON.stringify(map) as Stringified<string>,
    );
  }

  async getMeta(name: string): Promise<string | null> {
    await this.ready;
    const raw = await this.getDatabaseItem(META(name));
    return (raw as string) ?? null;
  }

  async setMeta(name: string, value: string): Promise<void> {
    await this.ready;
    await this.setDatabaseItem(META(name), value as Stringified<string>);
  }

  // ---- manutenção --------------------------------------------------------

  async clearAll(): Promise<void> {
    await this.ready;
    await this.clearDatabase();
  }
}

export const iconsIndexDB = new IconsIndexDB("icons-index", "icons-index-db");
